import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectDisplayScreens } from '@store/actionSlices/multiScreen'

import { ExpandSvg, MultiWindowSvg, PushToScreenSvg } from '@svg/react'

import { DisplayScreenStateMap } from '../../types'

interface CollapsedPanelProps {
  mirroringScreens: DisplayScreenStateMap
  onToggleCollapse: (value: boolean) => void
}

function CollapsedPanel({
  mirroringScreens,
  onToggleCollapse,
}: CollapsedPanelProps) {
  const displayScreens = useSelector(selectDisplayScreens)

  const mirroredScreensCount = useMemo(
    () => Object.values(mirroringScreens).filter(Boolean).length,
    [mirroringScreens]
  )

  const pushedToScreensCount = useMemo(
    () =>
      displayScreens.filter(
        (displayScreen) => !mirroringScreens[displayScreen.masterKey]
      ).length,
    [displayScreens]
  )

  const handleExpand = () => {
    onToggleCollapse(false)
  }

  return (
    <div className="rounded-lg bg-[rgba(0,0,0,0.5)] shadow-[0_8px_24px_0_rgba(0,0,0,0.25)] backdrop-blur-[12px]">
      <div className="px-4 py-3">
        {/* Expand Button */}
        <button
          type="button"
          onClick={handleExpand}
          className="flex w-full items-center justify-center"
        >
          <ExpandSvg size="m" width="24" height="24" strokeColor="white" />
        </button>
      </div>

      <hr className="bg-[#F8F9F6] opacity-25" />

      <div className="flex flex-col gap-4 px-4 py-4">
        {/* Mirror Button */}
        <button
          type="button"
          onClick={handleExpand}
          className="flex items-center justify-center rounded-lg bg-[rgba(3,141,254,0.50)] p-[10px]"
        >
          <div className="relative">
            <MultiWindowSvg
              size="m"
              width="24"
              height="24"
              strokeColor="white"
              stroke={2}
            />
            {mirroredScreensCount > 0 && (
              <div className="absolute -right-2 -top-1 flex h-[18px] w-[18px] items-center justify-center rounded-full border border-white bg-[#48A645]">
                <span className="mt-0.5 text-[15px] font-semibold text-white">
                  {mirroredScreensCount}
                </span>
              </div>
            )}
          </div>
        </button>

        {/* Push to Screen Button */}
        <button
          type="button"
          onClick={handleExpand}
          className="flex items-center justify-center rounded-lg bg-[rgba(3,141,254,0.50)] p-[10px]"
        >
          <div className="relative">
            <PushToScreenSvg
              size="m"
              width="24"
              height="24"
              strokeColor="white"
              stroke={2}
            />
            {mirroredScreensCount > 0 && (
              <div className="absolute -right-2 -top-1 flex h-[18px] w-[18px] items-center justify-center rounded-full border border-white bg-[#48A645]">
                <span className="mt-0.5 text-[15px] font-semibold text-white">
                  {pushedToScreensCount}
                </span>
              </div>
            )}
          </div>
        </button>
      </div>
    </div>
  )
}

export default CollapsedPanel
